import { convertDateToUnix, getLastNDays } from 'src/utils/utils';
import axios from './index';

export const getReqHistoryRequest = (filterObj = {}) => {
  const { issuerID, userID, status, fromDate, toDate } = filterObj;
  return axios.get(
    `v1/admins/gw-request-histories/get/gw-request-histories/-/${
      issuerID || '-'
    }/${userID || '-'}/${status || '-'}/${
      fromDate || convertDateToUnix(getLastNDays(30))
    }/${toDate || convertDateToUnix(getLastNDays(0))}/-/-`
  );
};

export const getIssuerReqHistoryRequest = (filterObj = {}) => {
  const { issuerID, userID, page, status, from, to, limit } = filterObj;
  return axios.get(
    `v1/issuer-staffs/gw-request-histories/get/gw-request-histories/-/${
      userID || '-'
    }/${page || '-'}/${limit || '-'}/${page || '-'}/${limit || '-'}`
  );
};
